import React, {useEffect, useState} from "react";
import {Link, Redirect} from "react-router-dom";
// reactstrap components
import {
    Button,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Media,
    Nav,
    Navbar,
    UncontrolledDropdown
} from "reactstrap";
import businessHelper from "../../helpers/BusinessHelper";
import businessApiService from "../../api/business-api-service";
import subscriptionHelpers from "../../helpers/SubscriptionHelper";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import {useObservable} from "../utils/observable/observableHook";
import {localeService} from "../utils/observable/services";
import {resource_strings} from "../../translations/resource_translations";
import SupportModal from "../Alerts/SupportModal";
import lsHelpers from "../../helpers/LsHelper";
import LocaleModal from "../Alerts/LocaleModal";
import BusinessPickModal from "../Alerts/BusinessPickModal";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const AdminNavbar = (props) => {
    const locale = useObservable(localeService.locale);

    const [business, setBusiness] = useState(businessHelper.business());
    const [subUser, setSubUser] = useState(businessHelper.subUser());
    const [locales, setLocales] = useState([]);
    const [showSupportModal, setShowSupportModal] = useState(false);
    const [showBusinessPicker, setShowBusinessPicker] = useState(false);
    const [showLocales, setShowLocales] = useState(false);
    const [mustLogout, setLogout] = useState(false);
    const [toSubscription, setToSubscription] = useState(false);
    const [showSidebar, setShowSidebar] = useState(lsHelpers.getSidebarPosition());

    useEffect(() => {
        getUser()
        window.addEventListener('sidebar_toggle_in_sidebar', updateSideBarState);
        window.addEventListener('user_updated', updateUserData);
        window.addEventListener('locale_set', updateUserData);

        return () => {
            // Do unmounting stuff here
            window.removeEventListener('sidebar_toggle_in_sidebar', updateSideBarState);
            window.removeEventListener('user_updated', updateUserData);
            window.removeEventListener('locale_set', updateUserData);
        };
    }, []);

    function updateSideBarState() {
        setShowSidebar(false)
    }

    function updateUserData() {
        setBusiness(businessHelper.business())
        reloadLocales()
    }

    function reloadLocales() {
        businessApiService.current()
            .then(res => {
                setLocales(res.locales)
            })
            .catch((e) => {
                console.log(e.message ? e.message : "")
            });
    }

    function getUser() {
        businessApiService.current()
            .then(res => {
                businessHelper.saveBusiness(res.user);
                businessHelper.saveSubUser(res.current);

                setBusiness(res.user)
                setLocales(res.locales)
            })
            .catch((e) => {
                console.log(e.message ? e.message : "")
            });
    }

    function logout(e) {
        e.preventDefault()
        lsHelpers.logout()
        setLogout(true)
    }

    if ((!localStorage.getItem('at') || !localStorage.getItem('business')) || (mustLogout === true)) {
        return <Redirect from="*" to="/auth/login"/>
    }

    if (toSubscription === true) {
        localStorage.must_reload = true
        return <Redirect from="/" to="/admin/subscriptions"/>
        // return <Redirect from="/" to="admin?subscription=t"/>
    }

    function toSubscriptions(e) {
        e.preventDefault();
        setToSubscription(true)
    }

    const toggleSupportModal = () => {
        setShowSupportModal(!showSupportModal)
    };

    const toggleLocaleModal = () => {
        setShowLocales(!showLocales)
    };

    const toggleBusinessModal = () => {
        setShowBusinessPicker(!showBusinessPicker)
    };

    localize();

    function toggleSideBar(event) {
        event.preventDefault();
        window.dispatchEvent(new Event("sidebar_toggle", {}));
        setShowSidebar(!showSidebar)
    }

    function currentLocaleName() {
        if (locales && locales.length > 0) {
            const fixedLocale = locales.find((l) => {
                return l.fixed
            })

            if (fixedLocale) {
                return fixedLocale.title
            } else {
                const loc_id = businessHelper.currentLocale();
                const curLocale = locales.find((l) => {
                    return l.id == loc_id
                })

                if (curLocale) {
                    return curLocale.title
                } else {
                    return locales[0].title
                }
            }
        }
    }

    function showLocaleOptions(e) {
        if (e) e.preventDefault();

        if (locales && locales.length > 0) {
            const fixedLocale = locales.find((l) => {
                return l.fixed
            })

            if (fixedLocale) {
                return null
            } else {
                setShowLocales(true)
            }
        }
    }

    function selectLocale(e, locale) {
        if (e) e.preventDefault();
        businessHelper.saveCurrentLocale(locale.id);
        toggleLocaleModal()
        window.location.reload()
    }

    function makeBusinessList() {
        const sUser = businessHelper.subUser();
        if (!sUser.businesses || sUser.businesses.length === 0){
            toggleBusinessModal()
            window.location.reload()
        }
        else {
            return (sUser.businesses ?? []).concat({id: sUser.id, name: sUser.name + ` (${commonStrings.you})`})
        }
    }

    function selectBusiness(id) {
        toggleBusinessModal();
        businessApiService.setMaster(id)
            .then(res => {
                businessHelper.saveBusiness(res.user);
                businessHelper.saveSubUser(res.current);

                setBusiness(res.user)
                setLocales(res.locales)

                window.location.reload()
            })
            .catch((e) => {
                console.log(e.message ? e.message : "")
            });
    }

    function renderBusinessName() {
        return business && business.name ? business.name : "OPEN"
    }

    return (
        <>
            {showSupportModal === true &&
                <SupportModal toggleModal={toggleSupportModal}/>
            }

            {showLocales === true &&
                <LocaleModal toggleModal={toggleLocaleModal} locales={locales} setLocale={selectLocale}/>
            }

            {showBusinessPicker === true &&
                <BusinessPickModal toggleModal={toggleBusinessModal} businesses={makeBusinessList()} setBusiness={selectBusiness}/>
            }

            <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
                {!showSidebar &&
                    <Button size="sm" style={{marginLeft: 10}} onClick={e => toggleSideBar(e)}>
                        <i className="fas fa-bars"/>
                    </Button>
                }
                <Container fluid>
                    <Link
                        className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
                        to="/"
                    >
                        {props.brandText}
                    </Link>
                    {/*<Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">*/}
                    {/*  <FormGroup className="mb-0">*/}
                    {/*    <InputGroup className="input-group-alternative">*/}
                    {/*      <InputGroupAddon addonType="prepend">*/}
                    {/*        <InputGroupText>*/}
                    {/*          <i className="fas fa-search" />*/}
                    {/*        </InputGroupText>*/}
                    {/*      </InputGroupAddon>*/}
                    {/*      <Input placeholder="Search" type="text" />*/}
                    {/*    </InputGroup>*/}
                    {/*  </FormGroup>*/}
                    {/*</Form>*/}
                    <Nav className="align-items-center d-none d-md-flex" navbar>

                        {/*<ReactTooltip/>*/}

                        {locales && locales.length > 1 ?
                            (<Button style={{paddingTop: 4, paddingBottom: 4}}
                                     onClick={e => showLocaleOptions(e)}>{currentLocaleName()}</Button>)
                            :
                            (<Button
                                style={{paddingTop: 4, paddingBottom: 4}}
                                color="secondary"
                                size="sm"
                                data-type="dark"
                                place="bottom"
                                data-tip={resourceStrings.subscriptions.your_current_plan}
                                className="d-none d-md-flex"
                                onClick={e => toSubscriptions(e)}
                            >
                                <div
                                    className="description">{subscriptionHelpers.subscriptionPlan()}
                                </div>
                            </Button>)
                        }
                        <UncontrolledDropdown nav>
                            <DropdownToggle className="pr-0" nav>
                                <Media className="align-items-center rounded-circle">
                    <span className="avatar avatar-sm rounded-circle">
                      <img
                          alt="..."
                          src={business && business.logo ? business.logo : require("assets/img/theme/open-logo-gray.png")}
                      />
                    </span>
                                    <Media className="ml-2 d-none d-lg-block">
                      <span className="mb-0 text-sm font-weight-bold">
                        {renderBusinessName()}
                      </span>
                                    </Media>
                                </Media>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-arrow" right>

                                <DropdownItem className="noti-title" header tag="div">
                                    <h6 className="text-overflow m-0"></h6>
                                </DropdownItem>

                                <DropdownItem to="/admin/user-profile" tag={Link}>
                                    <i className="ni ni-settings-gear-65"/>
                                    <span>{commonStrings.navigation.profile}</span>
                                </DropdownItem>

                                <DropdownItem to="/admin/user-profile?subscription=t" tag={Link}>
                                    <i className="ni ni-spaceship"/>
                                    <span>{resourceStrings.subscriptions.subscription}</span>
                                </DropdownItem>

                                <DropdownItem onClick={() => setShowSupportModal(true)} tag={Link}>
                                    <i className="fas fa-envelope"/>
                                    <span>{commonStrings.navigation.support}</span>
                                </DropdownItem>

                                {subUser && subUser.master_ids && subUser.master_ids.length > 0 &&
                                    <>
                                        <DropdownItem divider/>
                                        <DropdownItem onClick={() => setShowBusinessPicker(true)} tag={Link}>
                                            <i className="fas fa-user-friends"/>
                                            <span>{commonStrings.navigation.switch_business}</span>
                                        </DropdownItem>
                                    </>
                                }

                                <DropdownItem divider/>

                                <DropdownItem href="#pablo" onClick={e => logout(e)}>
                                    <i className="ni ni-button-power"/>
                                    <span>{commonStrings.navigation.logout}</span>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </Nav>
                </Container>
            </Navbar>
        </>
    );

    function localize() {
        commonStrings.setLanguage(locale);
        resourceStrings.setLanguage(locale);
    }
};

export default AdminNavbar;
